import K_PopUpWorkspace from "../templates/K_PopUpWorkspace";
import { Component, ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface PopUpWorkspaceOptions extends ComponentOptions {
    components: Component[];
    fullWorkspace?: boolean | "true";
}

export class PopUpWorkspace extends TemplateComponent {

    options: PopUpWorkspaceOptions;
    content: {
        components: Component[];
    };

    constructor(options: PopUpWorkspaceOptions) {
        super(K_PopUpWorkspace, options);

        this.content = {
            components: options.components
        };
    }

    create() {
        var elem = $(`#${this.id}`);
        var popUpWidth = elem.parents(".k-window").width();

        if (!this.options.fullWorkspace) {
            elem.width(popUpWidth - 268 - 10); // 10 for padding, 268 for left column
        }
    }

}
